import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import configureStore from './store/configure';

import RequirementsSets from './requirements_sets';

import './styles.scss';
import { initialState } from '../requirements_constants';

export default class RequirementsSetIndex extends React.Component {
  static propTypes = {
    canAccessCrm: PropTypes.bool.isRequired,
    canExport: PropTypes.bool.isRequired,
    crmEmail: PropTypes.string.isRequired,
    investmentTypes: PropTypes.array.isRequired,
    paths: PropTypes.object.isRequired,
    propertyTypes: PropTypes.array.isRequired,
    stateOptions: PropTypes.array.isRequired,
    transactionTypes: PropTypes.array.isRequired
  };

  store = configureStore({
    paths: this.props.paths,
    requirementsSet: {
      emailGroup: null
    },
    search: {
      requirementsSets: [],
      isSearching: false,
      meta: {
        currentPage: 0,
        pageSize: 25,
        totalCount: 0,
        totalPages: 0
      }
    },
    savedSearches: {
      searches: [],
      loading: true,
      deleteSavedSearch: null
    },
    static: {
      defaultColumns: ['parentName', 'name', 'transactionTypeFormatted', 'propertyTypes'],
      investmentTypes: this.props.investmentTypes,
      transactionTypes: this.props.transactionTypes,
      stateOptions: this.props.stateOptions,
      propertyTypes: this.props.propertyTypes,
      canAccessCrm: this.props.canAccessCrm,
      crmEmail: this.props.crmEmail
    },
    session: {
      currentColumns: []
    },
    ui: {
      canExport: this.props.canExport,
      showColumnFilters: false
    },
    query: {
      ...initialState,
      addressFilter: { ...initialState.addressFilter },
      propertyFilter: { ...initialState.propertyFilter },
      page: 1,
      pageSize: 25
    }
  });

  render() {
    return (
      <Provider store={this.store}>
        <RequirementsSets />
      </Provider>
    );
  }
}
